import { Navigate, Outlet } from "react-router-dom";
import { Divider, Hidden } from "@mui/material";
import { PathConstant, KeyConstant } from "@/const";
import { StorageUtils } from "@/utils";
import { MainBody, MainContent, MainSidebarRoot } from "./MainLayout.style";
import MainHeader from "./components/MainHeader";
import MenuList from "./components/MenuList";

const MainLayout = () => {
  const isLogin = StorageUtils.getItem(KeyConstant.KEY_TOKEN);

  if (!isLogin) return <Navigate to={PathConstant.LOGIN} replace />;

  return (
    <>
      <MainHeader />
      <Divider />
      <MainBody>
        <Hidden mdDown>
          <MainSidebarRoot>
            <MenuList />
          </MainSidebarRoot>
        </Hidden>

        <MainContent maxWidth={false}>
          <Outlet />
        </MainContent>
      </MainBody>
    </>
  );
};
export default MainLayout;
